export default "__VITE_ASSET__C02X7BPw__"